import { ErrorCode } from '@planning/utils/ErrorCode/error-code-enum'
import {
  getDomainModelExceptionPayload,
  isDomainModelException,
} from '@planning/utils/ErrorCode/error-code-utils'
import { useTranslate } from '@tolgee/react'

export const useReleaseMessagesHandler = () => {
  const { t } = useTranslate()

  const getExceptionMessage = (error: any) => {
    if (isDomainModelException(error, ErrorCode.OperatorReferenceNumberNotUnique)) {
      const payload = getDomainModelExceptionPayload(
        error,
        ErrorCode.OperatorReferenceNumberNotUnique,
      )

      return t(
        'operatorReferenceNumberNotUnique',
        'Reference number {referenceNumber} already exists for operator {operator}',
        {
          operator: payload.operatorName,
          referenceNumber: payload.referenceNumber,
        },
      )
    }

    if (isDomainModelException(error, ErrorCode.ValidityDateInPast)) {
      const payload = getDomainModelExceptionPayload(error, ErrorCode.ValidityDateInPast)

      return t('validityDateInPast', 'The validity date cannot be in the past', {
        validityDate: payload.validityDate,
      })
    }

    return error?.response?.data?.detail ?? t('failedToSaveRelease', 'Failed to save release')
  }

  const getNumericReleaseSuccessMessage = (isEditMode: boolean) =>
    isEditMode
      ? t('numericReleaseUpdated', 'Numeric release updated successfully')
      : t('numericReleaseCreated', 'Numeric release created successfully')

  const getNonNumericReleaseSuccessMessage = (isEditMode: boolean) =>
    isEditMode
      ? t('nonNumericReleaseUpdated', 'Non-numeric release updated successfully')
      : t('nonNumericReleaseCreated', 'Non-numeric release created successfully')

  return {
    getExceptionMessage,
    getNonNumericReleaseSuccessMessage,
    getNumericReleaseSuccessMessage,
  }
}
